module.exports = __webpack_public_path__ + "images/marketing/content-background-patrick3.jpg";